module.exports = __webpack_public_path__ + "img/dz.28ef585e.png";